export default __webpack_public_path__ + "static/media/img_controle_videoGame.a34e133e.svg";